import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../elements";

export default function DonorTableComponent({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);

  const [alertModal, setAlertModal] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(tbody);
  }, [tbody]);

  const handleCheckbox = (event) => {
    const { name, checked } = event.target;

    if (name === "allCheck") {
      const checkData = data?.map((item) => {
        return { ...item, isChecked: checked };
      });
      setData(checkData);
    } else {
      const checkData = data?.map((item) =>
        item.name === name ? { ...item, isChecked: checked } : item
      );
      setData(checkData);
    }
  };

  return (
    <div className="mc-table-responsive">
      <table className="mc-table product">
        <thead className="mc-table-head primary">
          <tr>
            {thead.map((item, index) => (
              <th key={index}>{t(item)}</th>
            ))}
          </tr>
        </thead>
        <tbody className="mc-table-body even">
          {data?.map((item, index) => (
            <tr key={index}>
              <td title={index + 1}>
                <div className="mc-table-check">
                  <p>{item.donor_id}</p>
                </div>
              </td>
              <td>{item.first_name}</td>
              <td>{item.last_name}</td>
              <td>
                <div className="mc-table-check">
                  <p>{item.organization}</p>
                </div>
              </td>
              <td>{item.families}</td>
              <td>
                <div className="mc-table-check">
                  <p>{item.country}</p>
                </div>
              </td>

              <td>
                <div className="mc-table-action">
                  <AnchorComponent
                    to="/product-upload"
                    title="Edit"
                    className="material-icons edit"
                  >
                    {item.action.edit}
                  </AnchorComponent>
                  <ButtonComponent
                    type="button"
                    title="Delete"
                    className="material-icons delete"
                    onClick={() => setAlertModal(true)}
                  >
                    {item.action.delete}
                  </ButtonComponent>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={alertModal} onHide={() => setAlertModal(false)}>
        <div className="mc-alert-modal">
          <i className="material-icons">new_releases</i>
          <h3>are your sure!</h3>
          <p>Want to delete this product?</p>
          <Modal.Footer>
            <ButtonComponent
              type="button"
              className="btn btn-secondary"
              onClick={() => setAlertModal(false)}
            >
              {t("close")}
            </ButtonComponent>
            <ButtonComponent
              type="button"
              className="btn btn-danger"
              onClick={() => setAlertModal(false)}
            >
              {t("delete")}
            </ButtonComponent>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
}
